/**
 * 格式化银行卡号
 * @param cardNumber
 * @returns {*|string}
 */
export default (cardNumber) => {
    if (typeof cardNumber !== 'string') {
        return cardNumber;
    }

    return cardNumber.replace(/(?<=\d{4})\d+(?=\d{4})/," **** **** ")
}



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/formatBankCard.js